// Company logos (each company's own site icon, in public/logos) for accounts, platforms and
// prop firms. A prop account shows its firm's logo, any other account its broker's or platform's;
// with no logo the initials badge stays. Shown only to say where an account is, unchanged.
import { firmOf } from './business';

const LOGOS = {
  // Prop firms (business.js FIRMS names).
  Topstep: 'topstep', Apex: 'apex', MyFundedFutures: 'myfundedfutures', Lucid: 'lucid', Tradeify: 'tradeify',
  TradeDay: 'tradeday', 'Take Profit Trader': 'takeprofittrader', 'Alpha Futures': 'alphafutures',
  Earn2Trade: 'earn2trade', Bulenox: 'bulenox',
  // Platforms and brokers (account platforms and Add account choices).
  TopstepX: 'topstepx', Tradovate: 'tradovate', NinjaTrader: 'ninjatrader', Rithmic: 'rithmic', Tradesea: 'tradesea',
  IBKR: 'ibkr', Webull: 'webull', Schwab: 'schwab', Robinhood: 'robinhood',
};

// Brokers recognized in a personal account's name (ThinkOrSwim is Schwab's platform).
const BROKERS = [
  ['Schwab', /schwab|think\s*or\s*swim|\btos\b/i], ['IBKR', /\bibkr\b|interactive\s*brokers/i],
  ['Webull', /webull/i], ['Robinhood', /robinhood/i], ['Tradovate', /tradovate/i], ['NinjaTrader', /ninja\s*trader/i],
];

export const logoSrc = (key) => (LOGOS[key] ? `/logos/${LOGOS[key]}.png` : null);

// The logo for an account: its firm, else a broker in its name, else its platform.
export function accountLogo(account) {
  if (!account) return null;
  const firm = firmOf(account);
  if (LOGOS[firm]) return firm;
  const text = `${account.name || ''} ${account.externalId || ''}`;
  const broker = BROKERS.find(([, re]) => re.test(text));
  if (broker) return broker[0];
  return LOGOS[account.platform] ? account.platform : null;
}

// A badge (`.pf-badge`, sized by `size`: '' | 'pf-md' | 'pf-sm') with the logo, or the initials.
export function LogoBadge({ logo, size = '', className = 'pf-other', text = '•' }) {
  const src = logoSrc(logo);
  if (!src) return <span className={`pf-badge ${size} ${className}`} aria-hidden="true">{text}</span>;
  return (
    <span className={`pf-badge pf-logo ${size}`} aria-hidden="true">
      <img src={src} alt="" loading="lazy" />
    </span>
  );
}
